import Http from '@/http';
import AuthService from '@/service/auth/authService';
import router from '@/router';

export default {
  get(endpoint, headers = {}, params = {}) {
    return Http.get(endpoint, {
      headers: this.assignHeaders(headers),
      params,
    });
  },

  assignHeaders(headers) {
    if (!AuthService.isLoggedIn()) {
      router.push('/');
      throw new Error('Invalid session');
    }
    return Object.assign({}, headers);
  },

  post(endpoint, data = {}, headers = {}) {
    return Http.post(endpoint, data, {
      headers: this.assignHeaders(headers),
    });
  },

  put(endpoint, data = {}, headers = {}) {
    return Http.put(endpoint, data, {
      headers: this.assignHeaders(headers),
    });
  },

  delete(endpoint, headers = {}) {
    return Http.delete(endpoint, {
      headers: this.assignHeaders(headers),
    });
  },
};
